<script lang="ts">
  import { getLocale } from "#lib/locale.ts";
  import { PREVIEW_SHOWN } from "#lib/products/rows.ts";
  import type { RowPreview } from "#lib/products/rows.ts";
  import Shot from "#lib/shots/Shot.svelte";
  import type { Fit } from "#lib/shots/bands.ts";
  import { rowSources } from "#lib/shots/sources.ts";

  let {
    preview,
    fit,
    alt = "",
    fitted = false,
    loading = "lazy",
    priority = "auto",
  }: {
    preview: RowPreview;
    fit: Fit;
    alt?: string;
    fitted?: boolean;
    loading?: "lazy" | "eager";
    priority?: "low" | "auto";
  } = $props();

  const shown = $derived(PREVIEW_SHOWN[preview]);
  const whole = $derived(shown.whole === true);
  const sources = $derived(rowSources(getLocale(), preview, fit));
</script>

<div class={fitted ? "relative max-h-105 overflow-hidden" : "absolute inset-0"}>
  <div class={["window", shown.tone, fitted ? "fitted" : "absolute inset-0"]}>
    <Shot
      {sources}
      {alt}
      {loading}
      {priority}
      class={whole ? "size-full object-contain" : "block h-auto w-full"}
    />
  </div>
  {#if !whole}<div class="fade" aria-hidden="true"></div>{/if}
</div>

<style>
  .window {
    overflow: hidden;
    border: 1px solid var(--edge);
    border-bottom: 0;
    border-radius: var(--radius-card) var(--radius-card) 0 0;
  }

  .fitted {
    padding-bottom: var(--window-fade, 3.5rem);
  }

  .fade {
    position: absolute;
    inset: auto 0 0;
    height: var(--window-fade, 3.5rem);
    background: linear-gradient(to bottom, transparent, var(--window-under, var(--surface-1)));
    pointer-events: none;
  }

  .page {
    background: var(--surface-0);
  }

  .discord {
    background: var(--discord-canvas);
    border-color: var(--discord-edge);
  }
</style>
